import React from 'react';
import StaysLocation from 'components/LandingPageStaysLocation';
import LandingPageLayout from 'components/LandingPageLayout';
import RoomTypes from 'components/LandingPageRoomTypes';
import RoomsSlider from '../components/LandingPageCarousels/RoomsSlider';
import AmenitiesLiberty from '../components/LandingPageAmenitiesLiberty/AmenitiesLiberty';
import TitleSection from '../components/LandingPageTitleSection/TitleSection';
import Neighbourhood from '../components/LandingPageNeighbourhood/Neighbourhood';
import { TitleSectionBtn } from 'components/LandingPageTitleSection/TitleSectionBtn';
import Head from 'next/head';
import TwoBedroomsOneRow from 'components/LandingPageTwoBedrooms/oneRowTwoColumn';
import TitleSectionOne from 'components/LandingPageTitleSection/TitleSectionOne';
import TitleSectionThree from 'components/LandingPageTitleSection/TitleSectionThree';
import PropertyViewer from 'components/LandingpagePropertyViewer';
import FeaturesSlider from 'components/LandingPageCarousels/FeaturesSlider';

const YorkUniSoulrooms = () => {
  const data = {
    roomSlider: [
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider1.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider2.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider3.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider4.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider5.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider6.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider7.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider8.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider9.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider10.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider11.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider12.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider13.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider14.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider15.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider16.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider17.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider18.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider19.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider20.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider21.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider22.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider23.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider24.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider25.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider26.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider27.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider28.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider29.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider30.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider31.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider32.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider33.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider34.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider35.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider36.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider37.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider38.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider39.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider40.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider4.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider41.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider42.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider43.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider44.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider45.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider46.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider47.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider48.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider49.png',
      },
      {
        src: '/static/images/landingPages/YorkSliderLarge/yorkRoomSlider50.png',
      },
    ],
    // featuresSlider: [
    //   {
    //     src: 'static/images/landingPages/homeslider1.jpg',
    //   },
    //   {
    //     src: 'static/images/landingPages/homeslider3.jpg',
    //   },

    //   {
    //     src: 'static/images/landingPages/homeslider5.jpg',
    //   },
    //   {
    //     src: 'static/images/landingPages/homeslider6.jpg',
    //   },
    // ],
    featuresSlider: [
      {
        src: 'static/images/landingPages/homeslider1.jpg',
      },
      {
        src: 'static/images/landingPages/homeslider2.jpg',
      },
      {
        src: 'static/images/landingPages/homeslider3.jpg',
      },
      {
        src: 'static/images/landingPages/homeslider4.jpg',
      },
      {
        src: 'static/images/landingPages/homeslider5.jpeg',
      },
      {
        src: 'static/images/landingPages/homeslider6.png',
      },
      {
        src: 'static/images/landingPages/homeslider5.jpeg',
      },
    ],
  };
  return (
    <>
      <Head>
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Featured location - York University</title>
        <meta
          name="description"
          content="Make these beautiful rooms your home while you study hard at the university"
        />
        <meta name="author" content="SoulRooms" />
        <meta property="og:url" content="https://soulrooms.com/york-university-soulrooms" />
        <meta property="og:site_name" content="SoulRooms" />
        <meta property="og:title" content="Featured location - York University" />
        <meta
          property="og:description"
          content="Make these beautiful rooms your home while you study hard at the university"
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@soulroomsTO" />
        <meta name="twitter:title" content="SoulRooms" />
        <meta name="twitter:description" content="Featured location - York University" />
        <meta name="twitter:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta name="twitter:image:alt" content="SoulRooms" />
        <meta name="theme-color" content="#FCBD00" />
        <meta name="google-site-verification" content="w6cEiCyxsJzrruZP6CzL7X8wnD7E8gMMl4q9aU0P59U" />
        <link rel="canonical" href="https://www.soulrooms.com/york-university-soulrooms" />
      </Head>
      <LandingPageLayout>
        {/* STAY LOCATION SECTION  */}
        <StaysLocation
          href="/find-a-soulroom"
          img={'/static/images/landingPages/york-uni.png'}
          title={'YORK UNIVERSITY SOULROOMS'}
          location={
            <p
              className="fs-4 responsiveText text-capitalize  py-4-md py-4  "
              style={{ fontFamily: 'Josefin Sans', color: '#5E5E5E' }}>
              Location -
              <a
                href="https://www.google.com/maps/place/2+Hackett+Ave,
                +Toronto,+ON/@43.7679619,-79.4981194,19.01z
                /data=!4m13!1m7!3m6!1s0x882b2e214a42e1d7:
                0xcf01d40ef420da92!2s2+Hackett+Ave,+Toronto,
                +ON!3b1!8m2!3d43.7679456!4d-79.4982675!3m4!
                1s0x882b2e214a42e1d7:0xcf01d40ef420da92!8m2
                !3d43.7679456!4d-79.4982675"
                target="_blank"
                rel="noreferrer">
                <span className="text-decoration-underline fs-4	" style={{ color: '#946F00' }}>
                  {' '}
                  Hackett Ave & Cook Lane
                </span>
              </a>
            </p>
          }
          description={
            <p
              className="  responsiveText pt-xl-1 pb-2 pe-xl-1  "
              style={{ fontFamily: 'Josefin Sans', color: '#5E5E5E' }}>
              A 4-minute walk away from York University, this house promises to be the best-in-class option for
              post-graduate students. Newly furnished keeping the student lifestyle in mind, the rooms here are equipped
              with study spaces, microwaves, minifridges, and a well-laden patio.
            </p>
          }
          btnTitle={'Find your SoulRoom in this hub'}
        />

        {/* ROOM TYPES SECTION  */}
        <RoomTypes
          title="YORK UNIVERSITY SOULROOMS - ROOM TYPES | LOWER FLOOR"
          heading="At SoulRooms, we always have room for you!"
          bgcolor="black"
          bg="black"
          titleOne="Lower Floor - Room 1"
          titleTwo="Lower Floor - Room 2"
          titleThree="Lower Floor - Room 3"
          img="static/images/landingPages/yorkroomtype1.png"
          price="$900"
          p1="Single Occupancy"
          p2="Bathroom - Shared between 2 people"
          p3="Chest of drawers + Wardrobe"
          p4="Study Table and Chair"
          p5="Single Bed"
          regularImg="static/images/landingPages/yorkroomtype2.png"
          regularPrice="$1000"
          regularP1="Single Occupancy"
          regularP2="Bathroom - Shared between 2 people"
          regularP3="Storage space + Wardrobe"
          regularP4="Study Table and Chair"
          regularP5="Double Bed"
          enSuitImg="static/images/landingPages/yorkroomtype3.png"
          enSuitPrice="$1100"
          enSuitP1="Double Occupancy"
          enSuitP2="En-suite Bathroom"
          enSuitP3="Chest of drawers + Wardrobe"
          enSuitP4="Minifridge and microwave"
          enSuitP5="Study Table and Chair"
          enSuitP6="Queen bed"
          href1="https://my.matterport.com/show/?m=CqDmzP9xx8F&brand=0"
          href2="https://my.matterport.com/show/?m=CqDmzP9xx8F&brand=0"
          href3="https://my.matterport.com/show/?m=CqDmzP9xx8F&brand=0"
          soldOutOne={true}
          soldOutTwo={true}
          soldOutThree={true}
        />
        <TitleSectionBtn btnTxt="Book your stay at York University SoulRooms" bg="black" href="/renters" />

        {/* FEATURE SLIDER  */}
        <FeaturesSlider imageSource={data.featuresSlider} />

        {/* Room Types With Two columns */}
        <TwoBedroomsOneRow
          title="YORK UNIVERSITY SOULROOMS - ROOM TYPES | FIRST FLOOR"
          heading="Smile. It instantly lifts up the face and lights up the room."
          bgcolor="black"
          img="static/images/landingPages/yorktworoomtype1.png"
          imgTwo="static/images/landingPages/yorktworoomtype2.png"
          price="$1150"
          p1="Single Occupancy"
          p2="Bathroom - Shared between 2 people"
          p3="Chest of drawers + Wardrobe"
          p4="Study Table and Chair"
          p5="Minifridge and microwave"
          p6="Double Bed"
          enSuitPrice="$1050"
          enSuitP1="Single Occupancy"
          enSuitP2="Bathroom - Shared between 2 people"
          enSuitP3="Chest of drawers + Wardrobe"
          enSuitP4="Minifridge and microwave"
          enSuitP5="Study Table and Chair"
          enSuitP6="Single bed"
          titleOne="First Floor - Room 4"
          titleTwo="First Floor - Room 5"
          soldOutOne={true}
          soldOutTwo={true}
          href1="https://my.matterport.com/show/?m=CqDmzP9xx8F&brand=0"
          href2="https://my.matterport.com/show/?m=CqDmzP9xx8F&brand=0"
        />

        {/* Title Section */}

        <TitleSectionOne
          title="MORE THAN JUST A GREAT PLACE TO STAY!"
          btnTxt="Book your University soulRooms"
          bg="white"
          href="/renters"
        />

        {/* ROOM TYPES SECTION  */}

        <RoomTypes
          title="YORK UNIVERSITY SOULROOMS - ROOM TYPES | SECOND FLOOR"
          heading="Dear Bedroom, I love you to the moon and back!"
          bgcolor="black"
          bg="black"
          titleOne="Second Floor - Room 6"
          titleTwo="Second Floor - Room 7"
          titleThree="Second Floor - Room 8"
          img="static/images/landingPages/yorkroomtype4.png"
          price="$1300"
          p1="Double Occupancy"
          p2="En-suite Bathroom"
          p3="Chest of drawers + Wardrobe"
          p4="Study Table and Chair"
          p5="Minifridge, microwave & coffee machine"
          p6="Sofa cum bed"
          p7="Queen Bed"
          regularImg="static/images/landingPages/yorkroomtype5.png"
          regularPrice="$1100"
          regularP1="Single Occupancy"
          regularP2="Bathroom - Shared between 2 people"
          regularP3="Storage space + Wardrobe"
          regularP4="Study Table and Chair"
          regularP5="Minifridge and microwave"
          regularP6="Sofa cum bed"
          regularP7="Double Bed"
          enSuitImg="static/images/landingPages/yorkroomtype6.png"
          enSuitPrice="$950"
          enSuitP1="Single Occupancy"
          enSuitP2="Bathroom shared between two people"
          enSuitP3="Storage space + Wardrobe"
          enSuitP4="Study Table and Chair"
          enSuitP5="Minifridge and microwave"
          enSuitP6="Double bed"
          href1="https://my.matterport.com/show/?m=CqDmzP9xx8F&brand=0"
          href2="https://my.matterport.com/show/?m=CqDmzP9xx8F&brand=0"
          href3="https://my.matterport.com/show/?m=CqDmzP9xx8F&brand=0"
          soldOutOne={true}
          soldOutTwo={true}
          soldOutThree={true}
        />

        {/* Title Section */}

        <TitleSectionOne
          title="AT SOULROOMS, SHARING IS SMART SAVING"
          btnTxt="Book your soulRooms"
          bg="white"
          href="/renters"
        />

        {/* Room Types With Two columns */}
        <TwoBedroomsOneRow
          title="YORK UNIVERSITY SOULROOMS - ROOM TYPES | THIRD FLOOR"
          heading="Bedgasm is real @SoulRooms."
          bgcolor="black"
          img="static/images/landingPages/yorktworoomtype3.png"
          imgTwo="static/images/landingPages/yorktworoomtype4.png"
          price="$1250"
          p1="Double Occupancy"
          p2="Bathroom - Shared between two people"
          p3="Private patio"
          p4="Chest of drawers + Wardrobe"
          p5="Study Table and Chair"
          p6="Minifridge and microwave"
          p7="Sofa cum bed"
          p8="Queen Bed"
          enSuitPrice="$950"
          enSuitP1="Single Occupancy"
          enSuitP2="Bathroom shared between two people"
          enSuitP3="Chest of drawers + Wardrobe"
          enSuitP4="Kitchenette with minifridge and microwave"
          enSuitP5="Study Table and Chair"
          enSuitP6="Double bed"
          titleOne="Third Floor - Room 9"
          titleTwo="Third Floor - Room 10"
          soldOutOne={true}
          soldOutTwo={true}
          href1="https://my.matterport.com/show/?m=CqDmzP9xx8F&brand=0"
          href2="https://my.matterport.com/show/?m=CqDmzP9xx8F&brand=0"
          href3="https://my.matterport.com/show/?m=CqDmzP9xx8F&brand=0"
        />

        <TitleSectionThree title="KNOW MORE" btnTxt="Schedule time with an expert" href="/soulrooms-demo-call" />

        {/* ROOMS SLIDER  */}
        <RoomsSlider
          imageSource={data.roomSlider}
          title="PHOTOS - YORK UNIVERSITY SOULROOMS"
          btnText="Reserve your spot"
          href="/renters"
        />

        {/* 3d Viewer  */}
        <PropertyViewer title="TOUR YORK UNIVERSITY SOULROOMS HERE:">
          <iframe
            width="853"
            height="480"
            src="https://my.matterport.com/show/?m=CqDmzP9xx8F&amp;brand=0"
            frameBorder={0}
            allowFullScreen
            allow="vr"></iframe>
        </PropertyViewer>

        {/* AMENITIES SECTION  */}
        <AmenitiesLiberty
          heading="AMENITIES"
          title1="In-unit Laundry"
          title2="Patio"
          title3="Lounge"
          img1={'/static/images/landingPages/pemanimities3.png'}
          img2={'/static/images/landingPages/yorkanimities1.png'}
          img3={'static/images/landingPages/yorkanimities2.png'}
        />

        {/* Neighbourhood section  */}
        <Neighbourhood
          title="Neighbourhood Highlights"
          img1="/static/images/landingPages/nabourpem1.png"
          img2="/static/images/landingPages/nabouryork1.png"
          img3="/static/images/landingPages/nabourpem3.png"
          cardTitle="Your Community Grocers"
          cardTitle2="Basil Box"
          cardTitle3="J's Bar & Restaurant"
          cardSubTitle="$"
          cardSubTitle2="$$"
          cardSubTitle3="$$"
          details="8 minutes away by walk from York University SoulRooms,
           this grocery store is the only place you'll need to visit to 
           complete your weekly grocery run. Also, they have weekend 
           sales from time to time!"
          details2="This is just one of the many pocket-friendly restaurants 
          located on Pond Road. With multiple Southeast Asian options to 
          chose from, Basil Box is a great healthy option thrown in 
          between pizza and cup noodles."
          details3="An ideal spot for pub grub & local brews that is
           known for its classic music coupled with some karaoke
            nights. A perfect place for a Friday evening 
            or a weekend afternoon if you are looking 
            to blow off some steam."
        />

        {/* TITLE SECTION  */}
        <TitleSection
          title="WANT TO KNOW MORE?"
          btnTxt="Chat with us on Messenger"
          bg="white"
          hrefExt="https://www.messenger.com/login.php?next=https%3A%2F%2Fwww.messenger.com%2Ft%2F404951336769102%2F%3Fmessaging_source%3Dsource%253Apages%253Amessage_shortlink"
        />
      </LandingPageLayout>
    </>
  );
};

export default YorkUniSoulrooms;
